module.exports = __webpack_public_path__ + "img/dummy.f41d91c6.jpg";